// Module
var code = "<img data-bind=\"attr: { src: $parent.GetValue(Name) }\" class=\"image-centered main-img img-cyber-grid\" alt=\"\">";
// Exports
export default code;